<script setup lang="ts">
export interface YscInputNumberProps {
  min?: number
  max?: number
  step?: number
}

withDefaults(defineProps<YscInputNumberProps>(), {
  step: 1,
})

const modelValue = defineModel<number>({
  default: 0,
})
</script>

<template>
  <div
    class="flex flex-row gap-3 items-center"
    v-bind="$attrs"
  >
    <!-- We'd probably need to add aria-label to the increase and decrease button, however that would probably add too much workload on the translation side  -->
    <button
      :id="$attrs['id'] ? `${$attrs['id']}-decrease-button` : undefined"
      role="button"
      type="button"
      :disabled="min !== undefined && modelValue <= min"
      class="ysc-input-number-stepper-btn"
      @click="modelValue -= step"
    >
      -
    </button>
    <slot :value="modelValue">
      <span>{{ modelValue }}</span>
    </slot>
    <button
      :id="$attrs['id'] ? `${$attrs['id']}-decrease-button` : undefined"
      role="button"
      type="button"
      :disabled="!!max && modelValue >= max"
      class="ysc-input-number-stepper-btn"
      @click="modelValue += step"
    >
      +
    </button>
  </div>
</template>

<style scoped>
.ysc-input-number-stepper-btn{@apply w-8 h-8 flex justify-center items-center rounded-xs outline-none border border-gray-300;@apply disabled:bg-gray-100 disabled:border-gray-200;@apply focus-visible:ring focus-visible:ring-peacock-200 focus-visible:ring-offset-2}
</style>
